import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { hoc } from '../../utils';
import { Button } from '../button';
import { useFormProps } from './form.props';
import styles from './form.module.scss';

/**
 * <Form />
 */
const Form = hoc(
  useFormProps,
  ({
    id,
    isError,
    question,
    last,
    mobileConfirmation,
    emailConfirmation,
    isQuestionAnswered,
    onMobileSendClick,
    onSendClick,
    onNextClick,
    onPrevClick,
    prevDisabled,
    children
  }) => (
    <div className={styles.form}>
      <div>{children}</div>
      <div className={styles.next}>
        {last ? (
          mobileConfirmation ? (
            <div className={styles.button}>
              <Link to={`/phone/?id=${id}`}>
                <Button
                  theme='primary'
                  onClick={onMobileSendClick}
                  disabled={isError}
                  rounded
                >
                  Далі
                </Button>
              </Link>
            </div>
          ) : emailConfirmation ? (
            <div className={styles.button}>
              <Link to={`/email/?id=${id}`}>
                <Button
                  theme='primary'
                  onClick={onMobileSendClick}
                  disabled={isError}
                  rounded
                >
                  Далі
                </Button>
              </Link>
            </div>
          ) : (
            <Button
              theme='primary'
              onClick={onSendClick}
              disabled={isError}
              rounded
            >
              {question?.button_name ? question.button_name : 'Надіслати'}
            </Button>
          )
        ) : (
          <div className={styles.buttons_field}>
            { /^9ce04ac2-1910-4afc-8efa-697c1d3cbd67$|^3fb41cc4-9c51-42e7-982c-8b393da3695a$|^e3f972bd-8faf-4c1a-b679-ec446796d6bf$|^a43e6f5e-dfe1-4414-b7b2-a42053740592$|^40be0eb5-f873-4473-862e-a392beb2bb29$|^68dc9646-c737-459e-bb88-826892f1f230$/.test(id) && (<Button
              className={classNames({
                [styles.button_disabled]: prevDisabled
              })}
              theme='primary'
              onClick={onPrevClick}
              rounded
            >
              Назад
            </Button> )}
            <Button
              className={classNames({
                [styles.button_disabled]:
                  question?.required && (isError || !isQuestionAnswered)
              })}
              theme='primary'
              onClick={onNextClick}
              rounded
            >
              Далі
            </Button>
          </div>
        )}
      </div>
    </div>
  )
);

export { Form };
